import React, { FC, ReactNode } from 'react'

export const TimeHorizonHighlighterIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container' data-testid='time-horizon-highlighter-icon'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/e966712472577f592f1cb8c04f36ee33_IS24_PleaseBePatient_highlighter.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/452b92f2a30273a9a24267d25b1236b4_IS24_PleaseBePatient_highlighter@2x.png 2x, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/21f210ae158055e294601b9300141ba5_IS24_PleaseBePatient_highlighter@3x.png 3x'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/e966712472577f592f1cb8c04f36ee33_IS24_PleaseBePatient_highlighter.png'
        }
        width={80}
        height={76}
        alt={''}
      />
    </div>
  )
}
